import wrapInObserver from '../wrapInObserver';
import GroupSelect from './GroupSelect';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';

const { useRootStore, useUiStore } = generatedHooks;

const makeSelectFormat = tabs => tabs.map(tab => ({ label: tab.label, value: tab.id }));

const mapProps = () => {
  try {
    const uiStore = useUiStore(store => store);
    const rootStore = useRootStore(store => store);

    const { reload } = rootStore;

    const {
      switchGroup,
      tabs,
      groupId,
      dropdownWidth,
    } = uiStore;

    const options = makeSelectFormat(tabs);
    const value = options.find(option => option.value === groupId);

    const handleGroupSelectChange = (option) => {
      const newGroupId = option.value;
      if (newGroupId !== groupId) {
        switchGroup(newGroupId);
        reload();
      }
    };

    return {
      options,
      value,
      handleGroupSelectChange,
      dropdownWidth,
    };
  } catch (error) {
    logger.error(error);
    return {};
  }
};

export default wrapInObserver(GroupSelect, mapProps);
